/** EPN-237: the notices that explain a status the caller cannot fully see, shared by the Employee Payslips list and the
 * Earning Statement. `subject` is "payslips" (list) or "payslip" (statement). Rendered on screen only (`no-print`). */
export function PayslipAvailabilityNotices({
  paymentStatusAvailable, reversalsAvailable, paymentFailedCount, subject,
}: {
  paymentStatusAvailable: boolean;
  reversalsAvailable: boolean;
  paymentFailedCount: number;
  subject: 'payslip' | 'payslips';
}) {
  const plural = subject === 'payslips';
  return (
    <>
      {!paymentStatusAvailable && (
        <p className="payslips__notice no-print" role="note" data-notice="payment-status-unavailable">
          Payment status is not available for your role; {plural ? 'payslips show' : 'this payslip shows'} as Approved.
        </p>
      )}
      {!reversalsAvailable && (
        <p className="payslips__notice no-print" role="note" data-notice="reversals-unavailable">
          Voided status is not available for your role; {plural ? 'a voided payslip may' : 'this payslip may'} show as Approved.
          {!plural && ' Year-to-date figures may include voided payslips.'}
        </p>
      )}
      {paymentFailedCount > 0 && (
        <p className="payslips__notice payslips__notice--warning no-print" role="note" data-notice="payment-failed">
          {plural
            ? `Payment failed for ${paymentFailedCount} ${paymentFailedCount === 1 ? 'payslip' : 'payslips'} on this page. ${paymentFailedCount === 1 ? 'It stays' : 'They stay'} Approved.`
            : 'Payment failed for this payslip. It stays Approved.'}
        </p>
      )}
    </>
  );
}
